<div class="stats-page">
    <!-- Summary Cards -->
    <div class="summary-cards">
        <div class="stat-card stat-card--orange">
            <div class="stat-card__icon">
                <i class="fa-solid fa-clock"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ totalExpiring | number }}</span>
                <span class="stat-card__label">Expiring Soon</span>
                <span class="stat-card__subtext">{{ totalExpiringBays | number }} bays at risk</span>
            </div>
        </div>
        <div class="stat-card stat-card--red">
            <div class="stat-card__icon">
                <i class="fa-solid fa-times-circle"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ totalExpiredNotRenewed | number }}</span>
                <span class="stat-card__label">Not Renewed</span>
                <span class="stat-card__subtext">in selected period</span>
            </div>
        </div>
        <div class="stat-card stat-card--green">
            <div class="stat-card__icon">
                <i class="fa-solid fa-arrows-rotate"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ renewalRate | number: '1.0-0' }}%</span>
                <span class="stat-card__label">Renewal Rate</span>
                <span class="stat-card__subtext">of recently expired contracts</span>
            </div>
        </div>
        <div class="stat-card stat-card--blue">
            <div class="stat-card__icon">
                <i class="fa-solid fa-coins"></i>
            </div>
            <div class="stat-card__content">
                <span class="stat-card__value">{{ formatCurrency(revenueAtRisk) }}</span>
                <span class="stat-card__label">Revenue at Risk</span>
                <span class="stat-card__subtext">monthly value of expiring subs</span>
            </div>
        </div>
    </div>

    <!-- Chart Grid -->
    <div class="chart-grid">
        <!-- Non-Renewal Reasons Pie -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-circle-xmark"></i>
                <h3>Non-Renewal Reasons</h3>
            </div>
            <div class="stats-card__chart" *ngIf="nonRenewalReasonChart.series.length > 0">
                <apx-chart
                    [series]="nonRenewalReasonChart.series"
                    [chart]="pieConfig"
                    [labels]="nonRenewalReasonChart.labels"
                    [colors]="nonRenewalReasonChart.colors"
                    [legend]="pieLegend"
                    [dataLabels]="pieDataLabels"
                    [responsive]="pieResponsive"
                ></apx-chart>
            </div>
            <div class="stats-card__empty" *ngIf="nonRenewalReasonChart.series.length === 0">
                <p>No data available</p>
            </div>
        </div>

        <!-- Renewal Status Pie -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-arrows-rotate"></i>
                <h3>Renewal Status</h3>
            </div>
            <div class="stats-card__chart" *ngIf="renewalStatusChart.series.length > 0">
                <apx-chart
                    [series]="renewalStatusChart.series"
                    [chart]="pieConfig"
                    [labels]="renewalStatusChart.labels"
                    [colors]="renewalStatusChart.colors"
                    [legend]="pieLegend"
                    [dataLabels]="pieDataLabels"
                    [responsive]="pieResponsive"
                ></apx-chart>
            </div>
            <div class="stats-card__empty" *ngIf="renewalStatusChart.series.length === 0">
                <p>No data available</p>
            </div>
        </div>

        <!-- By Parking Pie -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-square-parking"></i>
                <h3>By Parking</h3>
            </div>
            <div class="stats-card__chart" *ngIf="parkingChart.series.length > 0">
                <apx-chart
                    [series]="parkingChart.series"
                    [chart]="pieConfig"
                    [labels]="parkingChart.labels"
                    [colors]="parkingChart.colors"
                    [legend]="pieLegend"
                    [dataLabels]="pieDataLabels"
                    [responsive]="pieResponsive"
                ></apx-chart>
            </div>
            <div class="stats-card__empty" *ngIf="parkingChart.series.length === 0">
                <p>No data available</p>
            </div>
        </div>

        <!-- By Location Pie -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-location-dot"></i>
                <h3>By Location</h3>
            </div>
            <div class="stats-card__chart" *ngIf="locationChart.series.length > 0">
                <apx-chart
                    [series]="locationChart.series"
                    [chart]="pieConfig"
                    [labels]="locationChart.labels"
                    [colors]="locationChart.colors"
                    [legend]="pieLegend"
                    [dataLabels]="pieDataLabels"
                    [responsive]="pieResponsive"
                ></apx-chart>
            </div>
            <div class="stats-card__empty" *ngIf="locationChart.series.length === 0">
                <p>No data available</p>
            </div>
        </div>
    </div>

    <!-- Detail Tables Grid -->
    <div class="stats-grid">
        <!-- Non-Renewal Reason Table -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-circle-xmark"></i>
                <h3>Non-Renewal Reasons</h3>
            </div>
            <div class="stats-card__body">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>Reason</th>
                            <th class="text-right">Count</th>
                            <th class="text-right">Bays</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of byNonRenewalReason">
                            <td>
                                <span *ngIf="item.key !== 'Not Set'">{{ item.displayName }}</span>
                                <span *ngIf="item.key === 'Not Set'" class="text-muted">Not Set</span>
                            </td>
                            <td class="text-right">{{ item.count }}</td>
                            <td class="text-right">{{ item.bays }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Renewal Status Table -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-arrows-rotate"></i>
                <h3>Renewal Status</h3>
            </div>
            <div class="stats-card__body">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th class="text-right">Count</th>
                            <th class="text-right">Bays</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of byRenewalStatus">
                            <td>{{ item.displayName }}</td>
                            <td class="text-right">{{ item.count }}</td>
                            <td class="text-right">{{ item.bays }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- By User Responsible Table -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-user-check"></i>
                <h3>By User Responsible</h3>
            </div>
            <div class="stats-card__body">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th class="text-right">Count</th>
                            <th class="text-right">Bays</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of byUserResponsible">
                            <td>
                                <span *ngIf="item.key !== '0'" class="user-pill" [style.background-color]="item.badgeColor || '#6c757d'">
                                    {{ item.displayName }}
                                </span>
                                <span *ngIf="item.key === '0'" class="text-muted">Not Assigned</span>
                            </td>
                            <td class="text-right">{{ item.count }}</td>
                            <td class="text-right">{{ item.bays }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- By Lead Status Table -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-chart-pie"></i>
                <h3>By Lead Status</h3>
            </div>
            <div class="stats-card__body">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th class="text-right">Count</th>
                            <th class="text-right">Bays</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of byLeadStatus">
                            <td>
                                <span class="status-pill" [class]="'status-pill--' + item.key.toLowerCase()">
                                    {{ item.displayName }}
                                </span>
                            </td>
                            <td class="text-right">{{ item.count }}</td>
                            <td class="text-right">{{ item.bays }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- By Parking Table -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-square-parking"></i>
                <h3>By Parking</h3>
            </div>
            <div class="stats-card__body">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>Parking</th>
                            <th class="text-right">Count</th>
                            <th class="text-right">Bays</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of byParking">
                            <td>
                                <span *ngIf="item.key !== 'Unknown'">{{ item.displayName }}</span>
                                <span *ngIf="item.key === 'Unknown'" class="text-muted">Unknown</span>
                            </td>
                            <td class="text-right">{{ item.count }}</td>
                            <td class="text-right">{{ item.bays }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- By Location Table -->
        <div class="stats-card">
            <div class="stats-card__header">
                <i class="fa-solid fa-location-dot"></i>
                <h3>By Location</h3>
            </div>
            <div class="stats-card__body">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>Location</th>
                            <th class="text-right">Count</th>
                            <th class="text-right">Bays</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of byLocation">
                            <td>
                                <span *ngIf="item.key !== 'Not Set'">{{ item.displayName }}</span>
                                <span *ngIf="item.key === 'Not Set'" class="text-muted">Not Set</span>
                            </td>
                            <td class="text-right">{{ item.count }}</td>
                            <td class="text-right">{{ item.bays }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
